import { Col, Image, Row } from "react-bootstrap";
import ToggleButtonCustom from "../../components/templates/toggleBtn";
import Feedback from "./feedback";
import resume from "../../assets/images/resume/resume.svg";
import viewIcon from "../../assets/images/resume/view.svg";
import downloadIcon from "../../assets/images/resume/download.svg";
import resumeLoading from "../../assets/images/resume/resume-loading.svg";
import "../../assets/scss/components/sections/resumes/resumeJsonViewer.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner, faDownload } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import Skills from "./skills";
import ResumeViewer from "./resumeViewer";
import { download_file } from "./helper";
import {
  getToken,
  isTokenPresent,
  setLocalStorage,
} from "../../utils/userHelper";
import { useNavigate } from "react-router-dom";
const Resume = ({
  isLoading,
  isInsightsVisible,
  resumeData,
  downloadButtonClicked,
  isDownloading,
}) => {
  const navigate = useNavigate();

  return (
    <div>
      <div className="resume-section">
        <Row>
          <Col xl={isInsightsVisible ? 12 : 8} lg={6}>
            {isLoading ? (
              <div className="resume-loading">
                <div className="content">
                  <h3 className="heading-3">We are Getting Resume</h3>
                  <p className="pargraph">
                    Lörem ipsum protism soködade att pseudoligen semick,
                    transcism heteromatisk och heteroska Lörem ipsum protism
                    soködade att pseudoligen semick, transcism heteromatisk och
                    heteroska
                  </p>
                  <Image src={resumeLoading} className={"shimmer"} />
                </div>
              </div>
            ) : (
              <div>
                <div className="img">
                  <ResumeViewer resume={resumeData[0]} />
                  <div className="buttons">
                    <div
                      className={`icon download ${isDownloading && "disable"}`}
                      onClick={() => downloadButtonClicked()}
                    >
                      {isDownloading ? (
                        <FontAwesomeIcon
                          icon={faSpinner}
                          spin
                          size="lg"
                          color="white"
                        />
                      ) : (
                        <Image src={downloadIcon} alt="Download" />
                      )}
                    </div>
                  </div>
                </div>
                <Feedback
                  text="Did you liked the ResumeDetails?"
                  resumeId={resumeData[2]}
                  resumeSlug={resumeData[1].slug}
                />
              </div>
            )}
          </Col>
          <Col xl={4} lg={6} className={isInsightsVisible && "d-none"}>
            <Skills isLoading={isLoading} skillsData={resumeData[1]} />
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Resume;
